export default "__VITE_ASSET__nMJWRj04__"